import {
  PageHeader,
  Popconfirm,
  Select,
  Space,
  Tag,
  message,
  Tooltip,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { NotificacionPolizas, NotificacionMovimientosInventario, SelectItem, TableItem, ButtonItem, SegmentedItem } from "../../../Components/Items";
import { CloseCircleOutlined,CheckOutlined, FilePdfOutlined, EditOutlined, LockOutlined, UnlockOutlined } from "@ant-design/icons";
import ModalProductosAlCostoPdf from "./ModalProductosAlCostoPdf/ModalProductosAlCostoPdf";
import ModalApartarProductosAlCosto from "./ModalApartarProductosAlCosto/ModalApartarProductosAlCosto";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");
  
  const { Option } = Select;
  
  class ProductosAlCosto extends Component {
    state = {
      loading: false,
      objetoProyectos: [],
      todasProyectos: [],
      todasProductosAlCosto: [],
      proyecto: undefined,
      valor: 2,
      modalPdfVisible: false,
      ordenPdfId: null,
      ordenPdfNumero: null,
      modalApartarVisible: false,
      modalApartarModo: 'apartar',
      ordenApartarId: null,
      ordenApartarNumero: null,
    };
  
    async componentDidMount() {
      await this.consultarTodo(this.state.valor);
    }
  
    async consultarTodo(valor) {
      this.setState({ loading: true });
      await axios
        .post(
          "proyectos/selectProyectos",
          { empresaId: this.props.empresaId },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          if (res.data.status === 404) {
          } else {
            this.setState({ todasProyectos: res.data });
            this.setState({
              objetoProyectos: res.data.map((value) => {
                return (
                  <Option value={value._id} key={value._id}>
                    {value.nombre}
                  </Option>
                );
              }),
            });
          }
        });
      await axios
        .post(
          "productosAlCosto/selectTodasOrdenes",
          { empresaId: this.props.empresaId, valor: valor },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
            this.setState({ todasProductosAlCosto: [] });
          } else {
            this.setState({
                todasProductosAlCosto: res.data.map((value) => {
                return {
                  ...value,
                  proyectoNombre: value.proyecto.nombre,
                  accion: { _id: value._id, estado: value.estado, apartado: value.apartado },
                };
              }),
            });
          }
          this.setState({ loading: false });
        });
      this.setState({ loading: false });
    }
  
    onChangeProyecto(value) {
      if (value === 0) {
        this.setState({ loading: true, proyecto: undefined });
        axios
          .post(
            "productosAlCosto/selectTodasOrdenes",
            { empresaId: this.props.empresaId },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            if (res.data.status === 404) {
              this.setState({ todasProductosAlCosto: [] });
            } else {
              this.setState({
                todasProductosAlCosto: res.data.map((value) => {
                  return {
                    ...value,
                    proyectoNombre: value.proyecto.nombre,
                    accion: { _id: value._id, estado: value.estado, apartado: value.apartado },
                  };
                }),
              });
            }
            this.setState({ loading: false });
          });
      } else {
        const proyecto = this.state.todasProyectos.find(
          (valueState) => valueState._id.toString() === value.toString()
        );
        this.setState({ loading: true, proyecto: proyecto.nombre });
        axios
          .post(
            "productosAlCosto/selectTodasOrdenes",
            { empresaId: this.props.empresaId, proyectoId: value },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            if (res.data.status === 404) {
              this.setState({ todasProductosAlCosto: [] });
            } else {
              this.setState({
                todasProductosAlCosto: res.data.map((value) => {
                  return {
                    ...value,
                    proyectoNombre: value.proyecto.nombre,
                    accion: { _id: value._id, estado: value.estado, apartado: value.apartado },
                  };
                }),
              });
            }
            this.setState({ loading: false });
          });
      }
    }
    abrirProductosAlCosto() {
      this.props.history.push("/panel/agregarOrdenProductosAlCosto");
    }
    abrirModalApartar(modo, ordenId, numero) {
      this.setState({
        modalApartarVisible: true,
        modalApartarModo: modo,
        ordenApartarId: ordenId,
        ordenApartarNumero: numero,
      });
    }
    cerrarModalApartar(seMovioInventario) {
      this.setState({
        modalApartarVisible: false,
        ordenApartarId: null,
        ordenApartarNumero: null,
      });
      if (seMovioInventario) {
        this.consultarTodo(this.state.valor);
      }
    }
    confirmarProductosAlCosto(value) {
      this.setState({ loading: true });
      axios
        .post(
          "productosAlCosto/confirmarOrdenProductosAlCosto",
          { ordenId: value, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
            this.setState({ loading: false });
            if (res.data.success === 2) {
              message.success(
                "Se mandaron los productos al costo"
              );
              NotificacionPolizas(res.data.polizasId)
              NotificacionMovimientosInventario(res.data.movimientosIds)
            } else if (res.data.success === 1) {
              message.error(res.data.message ? res.data.message : "No hay suficiente inventario");
            } else {
              message.error("Hubo un error y el inventario no se redujo");
            }
          this.consultarTodo(this.state.valor);
        });
    }
    cancelarOrdenProductosAlCosto(value) {
      axios
        .post(
          "productosAlCosto/cancelarOrdenProductosAlCosto",
          { ordenId: value, empresaId: this.props.empresaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.success === 2) {
            message.success("Orden cancelada");
          } else {
            message.error(res.data.message ? res.data.message : "Sucedio un error y no se pudo cancelar");
          }
          this.consultarTodo(this.state.valor);
        });
    }
    render() {
      const columns = [
        {
          title: "Numero",
          dataIndex: "numero",
          key: "numero",
          sorter: (a, b) => {
            if (a.numero < b.numero) {
              return -1;
            }
            if (a.numero > b.numero) {
              return 1;
            }
            return 0;
          },
          buscar: "numero",
          width: "10%",
        },
        {
          title: "Fecha",
          dataIndex: "createdAt",
          key: "createdAt",
          sorter: (a, b) => {
            if (moment(a.createdAt) < moment(b.createdAt)) {
              return -1;
            }
            if (moment(a.createdAt) > moment(b.createdAt)) {
              return 1;
            }
            return 0;
          },
          render: (value) => moment(value).locale('es').format('L'),
          width: '10%',
        },
        {
          title: "Referencia",
          dataIndex: "referencia",
          key: "referencia",
          sorter: (a, b) => {
            if (a.referencia < b.referencia) {
              return -1;
            }
            if (a.referencia > b.referencia) {
              return 1;
            }
            return 0;
          },
          buscar: "referencia",
          width: "20%",
        },
        {
          title: "Proyecto",
          dataIndex: "proyectoNombre",
          key: "proyectoNombre",
          sorter: (a, b) => {
            if (a.proyectoNombre < b.proyectoNombre) {
              return -1;
            }
            if (a.proyectoNombre > b.proyectoNombre) {
              return 1;
            }
            return 0;
          },
          buscar: "proyectoNombre",
          width: "25%",
        },
        {
          title: "Estado",
          dataIndex: "estado",
          key: "estado",
          render: (value, record) => {
            if (value === 0) {
              return <Tag color="red" className="square-tag">Cancelada</Tag>;
            }
            if (value === 1) {
              return (
                <>
                  <Tag color="blue" className="square-tag">Por confirmar</Tag>
                  {!!record.apartado && <Tag color="gold" className="square-tag">Apartada</Tag>}
                </>
              );
            }
            if (value === 3) {
              return <Tag color="green" className="square-tag">Agregada</Tag>;
            }
          },
          width: "15%",
          ellipsis: true,
        },
        {
          title: "Acción",
          dataIndex: "accion",
          key: "accion",
          align: "center",
          width: "15%",
          onHeaderCell: () => ({
            style: { textAlign: 'center', padding: '4px' }
          }),
          onCell: () => ({
            className: "acciones-sin-hover",
            style: { textAlign: 'center', padding: '4px' }
          }),
          render: (value, index, record) => {
            if (value.estado === 0) return;

            let buttons = [];

            if (value.estado === 1) {
              buttons.push(
                <Tooltip key={`pdf-${index}`} title="Ver PDF">
                  <ButtonItem
                    size="small"
                    lila
                    icon={<FilePdfOutlined />}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.setState({ modalPdfVisible: true, ordenPdfId: value._id, ordenPdfNumero: record.numero });
                    }}
                  />
                </Tooltip>
              );
            }

            // Botón Editar (también disponible ya confirmada: revierte y regenera movimientos)
            if (this.props.permisoEditarOrdenProductosAlCosto) {
              buttons.push(
                <Tooltip
                  key={`editar-tip-${index}`}
                  title={value.estado === 3 ? "Editar orden confirmada (revierte y regenera movimientos)" : "Editar Orden"}
                  placement="top"
                  overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                >
                  <ButtonItem
                    size="small"
                    type="default"
                    icon={<EditOutlined />}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.props.history.push("/panel/editarOrdenProductosAlCosto", {
                        id: value._id,
                      });
                    }}
                  />
                </Tooltip>
              );
            }

            if (value.estado === 1 && this.props.permisoEditarOrdenProductosAlCosto) {
              // Apartar / Desapartar: reservan (o liberan) el inventario
              // mientras la orden sigue por confirmar. Puede ser parcial.
              buttons.push(
                <Tooltip
                  key={`apartar-${index}`}
                  title="Apartar inventario"
                  placement="top"
                  overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    amarillo2
                    icon={<LockOutlined />}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.abrirModalApartar('apartar', value._id, record.numero);
                    }}
                  />
                </Tooltip>
              );

              if (value.apartado) {
                buttons.push(
                  <Tooltip
                    key={`desapartar-${index}`}
                    title="Desapartar inventario"
                    placement="top"
                    overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                  >
                    <ButtonItem
                      type="default"
                      size="small"
                      icon={<UnlockOutlined />}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.abrirModalApartar('desapartar', value._id, record.numero);
                      }}
                    />
                  </Tooltip>
                );
              }
            }

            if (value.estado === 1) {
              // Botón Confirmar
              if (this.props.permisoConfirmarOrdenProductosAlCosto) {
                buttons.push(
                  <Popconfirm
                    key={`confirmar-${index}`}
                    title="Seguro que quieres confirmar esta orden de productos al costo"
                    onConfirm={() => this.confirmarProductosAlCosto(value._id)}
                    okText="Si"
                    cancelText="No"
                  >
                    <Tooltip title="Confirmar Orden" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                      <ButtonItem
                        type="default"
                        size="small"
                        lima
                        icon={<CheckOutlined />}
                      >
                      </ButtonItem>
                    </Tooltip>
                  </Popconfirm>
                );
              }

              // Botón Cancelar
              if (this.props.permisoCancelarOrdenProductosAlCosto) {
                buttons.push(
                  <Popconfirm
                    key={`cancelar-${index}`}
                    title="Seguro que quieres cancelar esta orden de productos al costo"
                    onConfirm={() => this.cancelarOrdenProductosAlCosto(value._id)}
                    okText="Si"
                    cancelText="No"
                  >
                    <Tooltip title="Cancelar Orden" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                      <ButtonItem
                        type="default"
                        size="small"
                        rojo
                        icon={<CloseCircleOutlined />}
                      >
                      </ButtonItem>
                    </Tooltip>
                  </Popconfirm>
                );
              }
            }

            return <div className="acciones-container">{buttons}</div>;
          },
        },
      ];
      return (
        <>
          <PageHeader
            title={
              this.state.proyecto
                ? "Ordenes Productos Al Costo: " + this.state.proyecto
                : "Ordenes Productos Al Costo: Todos"
            }
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <Space style={{ width: "100%", minWidth: 300 }}>
                {window.innerWidth > 1000 &&
                <SegmentedItem
                options={[{label: 'Agregada', value: 1}, {label: 'Por Confirmar', value: 2}, {label: 'Cancelada', value: 3}, {label: 'Todos', value: 4}]}
                onChange={(value) => {
                  this.consultarTodo(value)
                  this.setState({ valor: value })
                }}
                value={this.state.valor}
              />
            }
                <SelectItem
                  placeholder="Proyecto"
                  width={200}
                  onChange={this.onChangeProyecto.bind(this)}
                  defaultValue={0}
                >
                  <Option value={0}>Todos</Option>
                  {this.state.objetoProyectos}
                </SelectItem>
                {this.props.permisoAgregarOrdenProductosAlCosto &&
                  <ButtonItem
                    type="primary"
                    key="agregarInventario"
                    olivo
                    onClick={this.abrirProductosAlCosto.bind(this)}
                    style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                  >
                    Productos Al Costo
                  </ButtonItem>
                }
              </Space>
            }
          />
          <TableItem
            onRow={(record, rowIndex) => {
              return {
                onDoubleClick: (event) => {
                  this.props.history.push("/panel/verOrdenProductosAlCosto", {
                    id: record._id,
                  });
                },
              };
            }}
            size="small"
            dataSource={this.state.todasProductosAlCosto}
            columns={columns}
            pagination={false}
            loading={this.state.loading}
          />

          <ModalProductosAlCostoPdf
            visible={this.state.modalPdfVisible}
            onCancel={() => this.setState({ modalPdfVisible: false, ordenPdfId: null, ordenPdfNumero: null })}
            ordenId={this.state.ordenPdfId}
            ordenNumero={this.state.ordenPdfNumero}
          />

          <ModalApartarProductosAlCosto
            visible={this.state.modalApartarVisible}
            modo={this.state.modalApartarModo}
            ordenId={this.state.ordenApartarId}
            ordenNumero={this.state.ordenApartarNumero}
            cerrar={this.cerrarModalApartar.bind(this)}
          />
        </>
      );
    }
  }
  
  const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
      permisoAgregarOrdenProductosAlCosto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "647fc5549dc9c6543b161b8c"
      )?.activado,
      permisoConfirmarOrdenProductosAlCosto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "647fc4e39dc9c6543b161b8a"
      )?.activado,
      permisoCancelarOrdenProductosAlCosto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "647fc5049dc9c6543b161b8b"
      )?.activado,
      permisoEditarOrdenProductosAlCosto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a4d251bab8c795bc40e4a68"
      )?.activado,
    };
  };
  
  export default connect(mapStateToProps)(ProductosAlCosto);
  